export default __webpack_public_path__ + "static/media/cat-selected.c80ef450.svg";